import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SiteunderComponent } from './siteunder.component';
import { RouterModule, Routes } from '@angular/router';



@NgModule({
  declarations: [
    SiteunderComponent
  ],
  imports: [
    CommonModule,
    RouterModule
  ],
  exports:[SiteunderComponent]
})
export class SiteunderModule { }
